
export interface ISubscriptionStrings {
    page: ISubscriptionPageStrings
    statement: ISubscriptionStatementStrings;
}

export interface ISubscriptionPageStrings {
    description: string;
    plans: {
        Free: {
            title: string;
            label: string;
            summary: string;
            description: string;
            upgrade: {
                text: string;
                button_label: string;
            };
        };
        Basic: {
            title: string;
            label: string;
            summary: string;
            description: string;
        };
        Standard: {
            title: string;
            label: string;
            summary: string;
            description: string;
        };
        Premium: {
            title: string;
            label: string;
            summary: string;
            description: string;
        };
        home_ads: {
            title: string;
            label: string;
            summary: string;
            description: string;
        };
        data_labels: {
            limit: (limit) => string;
            adsLimit: (limit) => string;
            titles: {
                popular: string;
                welcome: string;
                hilevel: string;
            }
        };
    };
    title: string;
    we_recommend: string;
    subscribe: string;
};
export interface ISubscriptionStatementStrings {
    amount: string;
    discount: string;
    expires_label: string;
    modal_plans_title: string;
    modal_payment_title: string;
    nps: {
        subscribe_cancelment: string;
    };
    payment_frequency: {
        annual: string;
        monthly: string;
        semiannual: string;
    };
    payment_method: string;
    plan: string;
    subscription_max_items: (max: string) => string;
    status: {
        WAITING: SubscriptionsStatementStrings;
        ACTIVATED: SubscriptionsStatementStrings;
        CANCELLED: SubscriptionsStatementStrings;
    };
    title: string;
}

export interface SubscriptionsStatementStrings {
    title: string;
    badge_style: string;
    button_label?: string;
    cancel_button_label?: string | null;
    download_button_label?: string | null;
    modal_title?: string | null;
    modal_description?: string | null;
    modal_button_cancel_label?: string | null;
    modal_button_confirm_label?: string | null;
    dropdown?: {
        item1: {
            description: string;
        }
    }
}

export const SubscriptionStrings: {
    PTBR: ISubscriptionStrings
} = {
    PTBR: {
        page: {
            description: `Assinando qualquer um dos planos, você poderá anunciar mais peças e ter maior visibilidade no site ${process.env.REACT_APP_NAME}.<br />Ao fazer um anúncio, nós nos encarregaremos de notificá-lo assim que um usuário demonstrar interesse na peça anunciada.`,
            plans: {
                Free: {
                    title: "Livre",
                    summary: "Perfeito pra você experimentar nossa plataforma",
                    description: "Perfeito pra você experimentar nossa plataforma",
                    label: "",
                    upgrade: {
                        text: "Você está utilizando a assinatura livre. Faça um upgrade agora mesmo.",
                        button_label: "Upgrade"
                    }
                },
                Basic: {
                    title: "Bronze",
                    summary: "Ideal para quem quer mais visibilidade",
                    description: "Ideal para quem quer mais visibilidade. Anuncie até 200 peças e aumente suas chances de encontrar compradores rapidamente.",
                    label: ""
                },
                Standard: {
                    title: "Prata",
                    summary: "O plano intermediário para quem busca resultados consistentes",
                    description: "O plano intermediário para quem busca resultados consistentes. Com espaço para até 1000 peças, você terá ampla cobertura para suas ofertas.",
                    label: ""
                },
                Premium: {
                    title: "Ouro",
                    summary: "O melhor dos melhores!",
                    description: "O melhor dos melhores! Com capacidade ilimitada de anúncios, este plano é perfeito para os vendedores mais ambiciosos. Alcance o máximo de clientes e impulsione suas vendas.",
                    label: ""
                },
                home_ads: {
                    title: "Publicidade na Home",
                    summary: "Seus anúncios em destaque",
                    description: "Um verdadeiro Outdoor para todos os visitantes.",
                    label: "dias"
                },
                data_labels: {
                    limit: (limit) => `Publique até ${limit} peças`,
                    adsLimit: (limit) => `Publique até ${limit} anúncios`,
                    titles: {
                        popular: "Mais popular",
                        welcome: "Sua loja online",
                        hilevel: "Dominando os anúncios virtuais"
                    }
                },
            },
            subscribe: "Assinar o plano",
            title: "Seja um Anunciante",
            we_recommend: "Recomendado para iniciantes",
        },
        statement: {
            amount: 'Total do plano',
            discount: 'Desconto',
            expires_label: 'Data de Vencimento',
            modal_plans_title: 'Escolha o novo plano',
            modal_payment_title: 'Escolha a forma de pagamento',
            nps: {
                subscribe_cancelment: "Conte-nos o motivo de estar cancelando:",
            },
            payment_method: 'Pagamento',
            payment_frequency: {
                annual: "Anual",
                monthly: "Mensal",
                semiannual: "Semestral",
            },
            plan: 'Plano',
            subscription_max_items: (max) => `Limite de ${max} produtos`,
            status: {
                WAITING: {
                    title: 'Aguardando',
                    badge_style: 'warning',
                    cancel_button_label: 'Cancelar',
                    download_button_label: 'Boleto',
                    modal_title: "Troca de Plano",
                    modal_description: "Você está decidindo cancelar seu pedido de troca de plano.",
                    modal_button_cancel_label: "NÃO, foi sem querer",
                    modal_button_confirm_label: "SIM, pode cancelar"
                },
                ACTIVATED: {
                    title: "Ativo",
                    badge_style: "success",
                    button_label: 'Mudar de plano',
                    modal_title: "Cancelamento de Assinatura",
                    modal_description: "Cuidado, se você continuar a sua inscrição ativa será cancelada e você perderá o acesso à plataforma de anúncios.",
                    modal_button_cancel_label: "NÃO, foi sem querer",
                    modal_button_confirm_label: "SIM, pode cancelar",
                    dropdown: {
                        item1: {
                            description: "Cancelar Assinatura"
                        }
                    }
                },
                CANCELLED: {
                    title: "Cancelado",
                    badge_style: "danger",
                },
            },
            title: 'Extrato de Assinaturas'
        },
    },
};